import { FC, PropsWithChildren } from 'react';

import { ByLocales, Locales } from '@monoimin/sb-types';

import { FormButtonProps } from './constants';
import { getButtonStyle } from './utils';

/**
 * @deprecated Use FormSubmitButton instead
 */
export const FormButton: FC<PropsWithChildren<FormButtonProps>> = ({
  variant = 'primary',
  children,
  type = 'button',
  className,
  dataTestId,
  loading,
  size,
  theme = 'default',
  onClick,
  locale,
  disabled,
}) => {
  return (
    <button
      data-theme={theme}
      disabled={loading ?? disabled}
      type={type}
      onClick={onClick}
      className={getButtonStyle({
        variant,
        isForm: true,
        className,
        size,
      })}
      data-testid={dataTestId}
    >
      {loading ? dict[locale || 'en'] : children}
    </button>
  );
};

const dict: ByLocales<Locales, string> = {
  en: 'Loading...',
  de: 'Laden...',
  ru: 'Загрузка...',
  tr: 'Yükleniyor...',
  es: 'Cargando...',
};
